<template>
    <div>
        <detail-container id="main-section"/>
        <elementary-section shadow>
            <div class="container">
                <accessory-container id="accessory-section"/>
            </div>
        </elementary-section>
        <elementary-section shadow light>
            <div class="container">
                <h4 class="h4">Orientace</h4>
                <orientation-container id="orientation-section"/>
            </div>
        </elementary-section>
        <elementary-section shadow>
            <div class="container">
                <image-container id="image-section"/>
            </div>
        </elementary-section>
        <elementary-section shadow light>
            <div class="container">
                <file-container id="file-section"/>
            </div>
        </elementary-section>
    </div>
</template>

<script>
import ImageContainer from '@/modules/ProjectModule/modules/UnitModule/components/Image/ImageContainer';
import ElementarySection from '@/components/Content/ElementarySection';
import FileContainer from '@/modules/ProjectModule/modules/UnitModule/components/File/FileContainer';
import AccessoryContainer from '@/modules/ProjectModule/modules/UnitModule/components/Accessory/AccessoryContainer';
import DetailContainer from '@/modules/ProjectModule/modules/UnitModule/components/Detail/DetailContainer';
import OrientationContainer
    from '@/modules/ProjectModule/modules/UnitModule/components/Orientation/OrientationContainer';

export default {
    name:       'UnitContainer',
    components: {
        OrientationContainer,
        DetailContainer,
        AccessoryContainer,
        FileContainer,
        ElementarySection,
        ImageContainer,
    },
}
</script>
